import styled from 'styled-components'

export const StyledFileContainer = styled.div`
    padding-top: 5px;
`;
